import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getPost = async (
  id: string | number,
) => {
  const { data, error } = await supabase
    .from('posts')
    .select(`
      *,
      category:categories(*),
      profile:user_profiles (id, username),
      assetPrices:posts_assets (price_time_posting, asset_id),
      assets:assets!posts_assets (
        *,
        category:categories(*)
      )`)
    .eq('id', id)
    .single();

  if (error) {
    throw new Error(error.message)
  }

  data.assets = data.assets.map((a) => ({
    ...a,
    postingPrice: data.assetPrices
      .find((ap) => (ap.asset_id === a.asset_id))?.price_time_posting || 0,
  }))

  return data
}

export default function usePost(id) {
  const queryKey = ['post', id]
  return useQuery({
    queryKey,
    queryFn: () => getPost(id),
    enabled: Boolean(id),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
